export const MAX_BARCODE_LENGTH = 60

type BarcodeRange = {
  startPosition: number
  length: number
}

const MAX_BARCODE_LENGTH_ERROR_MESSAGE = `${MAX_BARCODE_LENGTH}以下を入力してください`
const BARCODE_TOTAL_LENGTH_ERROR_MESSAGE = `バーコードの桁数が${MAX_BARCODE_LENGTH}以下になるように調整してください`

export const getBarcodeEndPosition = (
  startPosition: number,
  length: number,
): number => startPosition + length - 1

const hasExceededBarcodeLength = ({ startPosition, length }: BarcodeRange) =>
  getBarcodeEndPosition(startPosition, length) > MAX_BARCODE_LENGTH

export const validateBarcodeStartPosition = ({
  startPosition,
  length,
}: BarcodeRange): string | undefined => {
  if (startPosition > MAX_BARCODE_LENGTH) {
    return MAX_BARCODE_LENGTH_ERROR_MESSAGE
  }

  if (hasExceededBarcodeLength({ startPosition, length })) {
    return BARCODE_TOTAL_LENGTH_ERROR_MESSAGE
  }

  return undefined
}

export const validateBarcodeLength = ({
  startPosition,
  length,
}: BarcodeRange): string | undefined => {
  if (length > MAX_BARCODE_LENGTH) {
    return MAX_BARCODE_LENGTH_ERROR_MESSAGE
  }

  if (hasExceededBarcodeLength({ startPosition, length })) {
    return BARCODE_TOTAL_LENGTH_ERROR_MESSAGE
  }

  return undefined
}
